import $ from 'jquery';
import 'foundation-sites';
import 'slick-carousel';
import 'jquery-mask-plugin';
import gsap from 'gsap';
import '../styles/app.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
import imagePath from '@images/spinner.gif'


window.$ = window.jQuery = $;

$(document).ready(function () {
  $(document).foundation();

  $('.hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('body').toggleClass('locked');
    $('.top-bar').toggleClass('open');
  });

  function addToggleAtBreakpoint() {
    if ($(window).width() <= 1024) {
      $('.menu li.menu-item-has-children').each(function () {
        if ($(this).find('.submenu-toggle').length === 0) {
          $(this).append('<span class="submenu-toggle"></span>');
        }
      });
    } else {
      $('.menu li.menu-item-has-children .submenu-toggle').hide();
    }
  }

  // Run on page load
  addToggleAtBreakpoint();

  // Run on window resize
  $(window).on('resize', function () {
    addToggleAtBreakpoint();
  });

  $('.top-bar').on('click', '.submenu-toggle', function () {
    $(this).toggleClass('open');
    $(this).parent().toggleClass('sub-active');
    $(this).prev().slideToggle();

    if ($('.submenu-toggle').hasClass('open')) {
      $('.top-bar').addClass('mob-overflow');
    } else {
      $('.top-bar').removeClass('mob-overflow');
    }
  });

  const $topBar = $('.top-bar');

  // Reset all submenus
  function resetSubmenus() {
    $topBar.find('li.parent').removeClass('keyboard-open');
    $topBar.find('.sub-menu').removeClass('visible').attr('aria-hidden', 'true');
    $topBar.find('.sub-menu a').attr('tabindex', '-1');
  }

  // Initial setup
  resetSubmenus();

  // Open submenu on keyboard (Enter or Space)
  $topBar.on('keydown', 'li.parent > a', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();

      const $parent = $(this).parent();
      const $submenu = $parent.find('.sub-menu');

      const isOpen = $parent.hasClass('keyboard-open');

      resetSubmenus(); // close all others first

      if (!isOpen) {
        $parent.addClass('keyboard-open');
        $submenu.addClass('visible').attr('aria-hidden', 'false');
        $submenu.find('a').attr('tabindex', '0');
      }
    }
  });

  function initAOS() {
    if (typeof AOS !== 'undefined') {
      AOS.init({
        once: true,
        offset: 160,               // Trigger slightly sooner
        duration: 1000,             // Shorter duration = faster animation
        easing: 'ease-in-out-back',   // Smoother, softer exit curve
      });
    }
  }

  setTimeout(() => {
    if (typeof AOS !== 'undefined') {
      AOS.refreshHard();
    }
  }, 500); // gives slick time to stabilize layout


  // Hero Link Checker (in-page versus off page)

  const heroLink = document.querySelector('.hero-area a');
  if (heroLink) {
    heroLink.addEventListener('click', function (e) {
      const href = heroLink.getAttribute('href') || '';
      if (href.charAt(0) === '#') {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          const top = target.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top,
            behavior: 'smooth'
          });
          history.replaceState(null, '', href);
        }
      }
    });
  }

  const hasPinScroll = document.querySelector('.pin-scroll-component');

  if (hasPinScroll) {
    // Delay AOS init until pin scroll layout is settled
    setTimeout(() => {
      initAOS();
    }, 500); // adjust if needed
  } else {
    // No pin scroll — safe to init immediately
    initAOS();
  }

});
